<template>
    <a-modal
      v-model="visible"
      title="选择对比原料"
      @ok="ok"
      width="700px"
      destroyOnClose
      @cancel="cancel"
    >
      <div class="differ">
        <a-space style="display: flex;">
          <a-select
            placeholder="请选择工厂"
            style="width: 200px;"
            v-model="formData.factoryId"
            @change="() => getList()"
          >
            <a-select-option v-for="d in factoryList" :key="d.factoryId">
              <a-tooltip>
                <template slot="title">
                  {{ d.name }}({{ d.code }})
                </template>
                {{ d.name }}
              </a-tooltip>
              
            </a-select-option>
          </a-select>
          <a-input
            style="width: 200px;"
            v-model="formData.name"
            placeholder="请输入原料名称/代码"
            allow-clear
            @pressEnter="() => getList()"
          >
            <a-tooltip slot="suffix" title="">
              <a-icon type="search" style="color: rgba(0, 0, 0, 0.45)" @click="() => getList()" />
            </a-tooltip>
          </a-input>
          <type-cascader @changeForm="changeForm" feild="typeId" />
        </a-space>
        
      </div>

      <!-- 表单 -->
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :scroll="{ y: 340 }"
        :row-selection="rowSelection"
        rowKey="id"
        :custom-row="customRow"
      >

        <template slot="name" slot-scope="text, record">
            <span>{{record.aliasName ? record.aliasName :record.name}}</span>
          </template>

      </a-table>
    </a-modal>
</template>

<script>
const columns = [
  {
    title: "原料名称",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "代码",
    dataIndex: "code",
  },
  {
    title: "类型",
    dataIndex: "rawTypeName",
  },
];
import TypeCascader from '../CommonConponents/TypeCascader.vue'
export default {
  props: ['factoryList','visible'],
  components: {TypeCascader},
  data() {
    return {
      factoryId: window.localStorage.getItem("factoryId"),
      formData: {
        name: "",
        typeId: "",
      },
      columns,
      list: [],
      selectedRowKeys: [], //保存table单选选中的id
      selectedRows: [], //保存table单选选中的对象
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize});
        }, //选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.pagination.pageSize = pageSize;
          this.getList({ current: 1, pageSize});
        }, //每页多少条
      },
      searchList: [], //输入框搜索值
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    rowSelection(){
      return {
        type: 'radio',
        onChange: (selectedRowKeys,selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
        },
        selectedRowKeys: this.selectedRowKeys,
      }
    }
  },
  methods: {
    
    customRow(record){
      return {
        on: {
          dblclick: () => {
            this.$emit('close',true,record)
          }
        }
      }
    },
    changeForm(data){
      this.formData = {...this.formData,...data}
      this.getList()
    },

    ok() {
      this.$emit('close',true,this.selectedRows[0])
    },

    cancel(){
      this.formData={}
      this.$emit('close')
    },
    //获取原料数据，可传入数据进行查询。
    async getList(pagination) {
      let {factoryId} = this.formData || {}
      let {pageSize,current} = pagination || this.pagination
      let params = {
        ...this.formData,
        current,
        size: pageSize,
        factoryId: factoryId ? factoryId : this.factoryId,
      };
      let res = await this.$get("/nhf-app/factorystaffraw/myRawpage", params);
      let { success, data } = res;
      if (success) {
        let {total,size,records} = data || {}
        this.list = records;
        this.pagination.total = total
        this.pagination.pageSize = size
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.differ {
  margin-bottom: 16px;
  display: flex;
  .ant-input-affix-wrapper {
    width: 250px;
    margin-right: 10px;
  }
}
.tableBox {
  padding: 0;
}
</style>